export default __webpack_public_path__ + "static/BlueCare logo-cc4b005236ecfa98f1d20d4a177b973a.png";